import React from 'react';
export function EditorialSplit() {
  return <section className="py-16 md:py-24" data-id="element-44">
      <div className="max-w-7xl mx-auto" data-id="element-45">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-46">
          <div className="aspect-[4/5] lg:aspect-auto" data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/7ouiHqvsUd6ZMdptyk67Li/IMG_0186.webp" alt="Pure Pulse lifestyle" className="w-full h-full object-cover" data-id="element-48" />
          </div>
          <div className="bg-mocha text-cream px-8 md:px-16 py-16 md:py-24 flex flex-col justify-center" data-id="element-49">
            <p className="text-xs uppercase tracking-widest mb-4" data-id="element-50">
              THE PURE PULSE WAY
            </p>
            <h2 className="font-serif font-light text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-51">
              Designed for the way you move.
            </h2>
            <p className="text-lg mb-8 leading-relaxed" data-id="element-52">
              Buttery-soft technical fabrics that sculpt and support. A
              second-skin fit that moves with you. Pieces that transition
              seamlessly from studio to street.
            </p>
            <a href="https://shop.purepulsepilates.com" className="inline-block text-cream uppercase tracking-widest text-sm border-b border-rust pb-1 hover:text-rust transition-colors self-start" data-id="element-53">
              EXPLORE THE COLLECTION
            </a>
          </div>
        </div>
      </div>
    </section>;
}